import React, { createContext, useState } from "react";

export const SearchCurrentStakeholderContext = createContext({});

export const initialSearchValues = {
  companyName: "",
  yearOfBudgetList: [],
  customerDateFrom: "",
  customerDateTo: "",
  customerTypeList: [],
  topicList: [],
  nationalityList: [],
  contactName: "",
  contactPhone: "",
  contactPosition: "",
  staffName: "",
  staffDetail: "",
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  total: 0,
  totalPage: 0,
  sortBy: "yearOfBudget",
  sortDirection: "ASC",
};

const SearchCustomerStakeholderProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchCurrentStakeholderContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchCurrentStakeholderContext.Provider>
  );
};

export default SearchCustomerStakeholderProvider;
